(function (window, document, undefined) {


  window.sectionTestimonials = {


    addListeners: () => {
      
      let testimonials = document.querySelectorAll('.s_testimonials:not(.event_is_set)');
      if (testimonials.length) {
          
        [].forEach.call(testimonials, (obj) => {

          const _C = obj, N = _C.querySelectorAll('.box').length;
          let i = 0, x0 = null;

          function unify(e) {
            return e.changedTouches ? e.changedTouches[0] : e
          }

          function lock(e) {
            x0 = unify(e).clientX;
          }

          function move(e) {
            let dx = unify(e).clientX - x0, s = Math.sign(dx);
            // console.log(`s: ${s} | i: ${i} `);

            if (x0 || x0 === 0) {

              if (s == -1 && i == (N-1)) {

                // console.log('next on last');
                _C.style.setProperty('--i', i = 0);
                updateActiveClass();
              
              } else if (s == 1 && i == 0) {
              
                // console.log('back from 0');
                _C.style.setProperty('--i', i = (N-1));
                updateActiveClass();
              
              } else if ((i > 0 || s < 0) && (i < N - 1 || s > 0)) {
              
                _C.style.setProperty('--i', i -= s);
                updateActiveClass();
              
              }

              x0 = null;
            }
          }

          function updateActiveClass() {
            for (let j = 0; j < N; j++) {
              const child = _C.querySelectorAll('.box')[j];
              if (j === i) {
                child.classList.add('is_active');
              } else {
                child.classList.remove('is_active');
              } 
            }
          }

          _C.style.setProperty('--n', N);
          _C.addEventListener('mousedown', lock, false);
          _C.addEventListener('touchstart', lock, false);
          _C.addEventListener('mouseup', move, false);
          _C.addEventListener('touchend', move, false);

          obj.classList.add('event_is_set')
        });
      }

    },


    init: () => {
      
      let testimonials = document.querySelectorAll('.s_testimonials');
      if (testimonials.length) {
        [].forEach.call(testimonials, (e) => {
          let boxes = e.querySelectorAll('.box');

          if (boxes.length) {
            boxes[0].classList.add('is_active');
          }
          
          console.log(boxes);
        });
      }

      window.sectionTestimonials.addListeners();

    }


  }


})(window, window.document);


document.addEventListener('DOMContentLoaded', () => {
    
  window.sectionTestimonials.init();

});
